import React from "react";
import { WithFieldValue, DocumentData } from "firebase/firestore";
import { Alert, Text } from "@chakra-ui/react";

import { PRODUCTION_STEPS_AUX } from "@constants";
import { useCustomToast } from "@hooks";

import {
  JsonForm,
  JsonFormControl,
  makeCommentsControl,
  makeSelectControl,
} from "../JsonForm";
import { ButtonModal } from "../ModalWrappers";
import { useAddAuxStep } from "./useAddAuxStep";

type AddDetachVTRXModalProps = {
  itemId: string;
};

function makeDetachVTRXControl() {
  const tags = ["Yes"];
  return [
    makeSelectControl(
      "Detach?",
      "detach",
      tags,
      "Please confirm that you are detaching VTRX.",
    ),
    makeCommentsControl(),
  ] as JsonFormControl[];
}

export function AddDetachVTRXModal({ itemId }: AddDetachVTRXModalProps) {
  const tagFormControl = React.useMemo(() => makeDetachVTRXControl(), []);
  const addTagToast = useCustomToast(() => (
    <Alert status="success">VTRX detached!</Alert>
  ));
  const [error, setError] = React.useState("");
  const addStep = useAddAuxStep(
    itemId,
    PRODUCTION_STEPS_AUX.STEP_AUX_DETACH_VTRX,
    addTagToast,
    setError,
  );
  const doSubmit = React.useCallback(
    async function <T extends WithFieldValue<DocumentData>>(data: T) {
      const comments = "Detaching VTRX";
      (data.comments ? (data.comments as string) + ", " : "") +
        "detaching VTRX";
      addStep(comments);
    },
    [addStep],
  );

  return (
    <ButtonModal label="Detach VTRX" title="Detach VTRX" size="sm">
      <JsonForm fields={tagFormControl} onSubmit={doSubmit} clearAfterSubmit />
      {error ? <Text>{error}</Text> : undefined}
    </ButtonModal>
  );
}
